import { useNavigate } from "react-router-dom";
import PavementDesign from "../../components/PavementDesign/PavementDesign";
import "../PageCommon.css";
import "./PavementDesign.css";
import { useEffect } from "react";

const PavementDesignPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);

  return (
    <div className="page__container">
      <div className="page__body">
        <PavementDesign />
      </div>
    </div>
  );
}

export default PavementDesignPage;